var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPanelIconDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1428 19.032C24.2079 19.032 25.0713 19.8954 25.0713 20.9606V23.8534C25.0713 24.9186 24.2079 25.782 23.1428 25.782H3.85704C2.79191 25.782 1.92847 24.9186 1.92847 23.8534V20.9606C1.92847 19.8954 2.79193 19.032 3.85704 19.032H23.1428Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.6391C14.5651 2.6391 15.4285 3.50256 15.4285 4.56767V13.2462C15.4285 14.3114 14.5651 15.1748 13.5 15.1748H3.7252C2.66009 15.1748 1.79663 14.3114 1.79663 13.2462L1.79663 4.56767C1.79663 3.50254 2.66009 2.6391 3.7252 2.6391H13.5Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0467 2.6391C24.5794 2.6391 25.011 3.07083 25.011 3.60338V6.0141C25.011 6.54665 24.5794 6.97838 24.0467 6.97838H20.2499C19.7175 6.97838 19.2856 6.54665 19.2856 6.0141V3.60338C19.2856 3.07083 19.7175 2.6391 20.2499 2.6391H24.0467Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0467 10.8355C24.5794 10.8355 25.011 11.2672 25.011 11.7998V14.2105C25.011 14.7431 24.5794 15.1748 24.0467 15.1748H20.2499C19.7175 15.1748 19.2856 14.7431 19.2856 14.2105V11.7998C19.2856 11.2672 19.7175 10.8355 20.2499 10.8355H24.0467Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPanelIconDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/panelIcon_dark.212824819dc9204854360aa7773cfe4d.svg";